<template>
  <div class="awards" v-if="AwardWinnersData">
    <HeadBlock />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <div class="container">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t('金曲獎') }}</li>
          <li class="breadcrumb-item active" aria-current="page" v-if="AwardWinnersData.AwardWinners_Name">{{
            AwardWinnersData.AwardWinners_Name }}</li>
        </div>
      </ol>
    </nav>
    <a accesskey="c" id="accesskey_c" href="#" title="中間主要內容區">
      :::
    </a>
    <div class="main shortList" v-if="AwardWinnersData.AwardWinners_Name">
      <div class="container">
        <div class="title">
          <h2>{{ AwardWinnersData.AwardWinners_Name }}</h2>
        </div>
        <div class="box">
          <!-- Tab切換部分 -->
          <div class="tabs">
            <ul class="btn_box">
              <li v-for="(categoryTab, categoryIndex) in categoryTabs" :key="categoryIndex">
                <button :class="['category_btn', { active: selectedTab === categoryIndex }]"
                  @click="selectTab(categoryIndex)" :aria-selected="selectedTab == categoryIndex ? 'true' : 'false'"
                  :aria-expanded="selectedTab == categoryIndex ? 'true' : 'false'">
                  {{ categoryTab.category }}
                </button>
              </li>
            </ul>
          </div>
          <!-- 內容 -->
          <div class="content">
            <!-- 只顯示當前選中的 Tab 對應的內容 -->
            <div v-for="(title, index) in categoryTabs[selectedTab].titles" :key="index">
              <button class="title" @click="toggleGroup(index)" :aria-expanded="isGroupOpen[index] ? 'true' : 'false'">
                <div class="plus" :class="{ add: isGroupOpen[index] }"
                  :aria-selected="isGroupOpen[index] ? 'true' : 'false'"></div>
                <p>{{ title.title }}</p>
              </button>
              <div class="group" v-show="isGroupOpen[index]">
                <ul class="list">
                  <li v-for="(item, index) in title.items" :key="index">
                    <p :style="local == 'en' ? 'padding: 5px 20px;' : ''">
                      <span v-if="item.winner" class="winning">{{ $t('得獎') }}</span>{{ item.text }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FooterBlock />
  </div>
</template>
<script>
import HeadBlock from "@/components/HeadBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "金曲獎": "金曲獎",
    "金曲國際音樂節": "金曲國際音樂節",
    "得獎": "得獎",
  },
  en: {
    "首頁": "Home",
    "金曲獎": "Golden Melody Awards",
    "金曲國際音樂節": "Golden Melody Festival",
    "得獎": "winner",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "AwardWinners",
  i18n,
  components: {
    Slick,
    HeadBlock,
    FooterBlock,
  },
  data() {
    return {
      AwardWinnersData: {},
      selectedTab: 0,  // 預設選中的頁籤
      isGroupOpen: [], // 每個tab的group是否展開
      categoryTabs: null,
      local: "zh_tw",
    };
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src + this.$store.state.subDirectory + "/Html/AwardWinners",
    //     {
    //       params: {
    //         lang: $cookies.get("gma_the_site_lang")
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.AwardWinnersData = response.data;
    //     this.categoryTabs = this.AwardWinnersData.AwardWinners_Menu;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });    
    if ($cookies.get("gma_the_site_lang") == "zh_tw") {
      this.AwardWinnersData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "AwardWinners_Name": "第36屆金曲獎入圍名單",
        "AwardWinners_Menu": [
          {
            "category": "演唱類 - 出版獎",
            "titles": [
              {
                "title": "年度專輯獎",
                "items": [
                  {
                    "text": "最佳華語專輯獎",
                    "winner": false
                  },
                  {
                    "text": "最佳台語專輯獎",
                    "winner": false
                  },
                  {
                    "text": "最佳客語專輯獎",
                    "winner": false
                  },
                  {
                    "text": "最佳原住民語專輯獎",
                    "winner": false
                  },
                  {
                    "text": "Suí 水／果核音樂玫瑰森林農場有限公司﹙演唱者：李竺芯﹚",
                    "winner": true
                  }
                ]
              },
              {
                "title": "年度歌曲獎",
                "items": [
                  {
                    "text": "BUNUN 布農《QUEENDOM》／華納國際音樂股份有限公司（演唱者：阿布絲・塔娜比瑪／作曲人：阿布絲、張少瑜／作詞人：阿布絲）",
                    "winner": false
                  },
                  {
                    "text": "手機錢包鑰匙菸 (Ft. 盧廣仲)《美秀集團同名專輯》／火玄火包股份有限公司（演唱者：美秀集團、盧廣仲／作曲人：修齊(劉修齊)、盧廣仲／作詞人：修齊(劉修齊)、盧廣仲）",
                    "winner": false
                  },
                  {
                    "text": "偏南風《偏南》／三川娛樂有限公司（演唱者：謝銘祐／作曲人：謝銘祐／作詞人：謝銘祐）",
                    "winner": false
                  },
                  {
                    "text": "Young Man《AAA》／夕陽音樂產業有限公司（演唱者：AAA (HYUKOH & 落日飛車)／作曲人：OHHYUK 오혁 (吳赫)、曾國宏／作詞人：OHHYUK 오혁 (吳赫)、JNKYRD 권성철、曾國宏）",
                    "winner": false
                  },
                  {
                    "text": "星期五晚上《Here I Am》／相信音樂國際股份有限公司（演唱者：Energy／作曲人：Oliver Kim、張簡君偉／作詞人：何宇勝、任遲、Oliver Kim）",
                    "winner": true
                  },
                  {
                    "text": "才二十三《夢想家》／香港商賦音樂有限公司（演唱者：方大同／作曲人：方大同／作詞人：方大同）",
                    "winner": false
                  },
                  {
                    "text": "這樣很好 - 《英雄聯盟:雙城之戰》動畫第二季原聲《這樣很好 - 《英雄聯盟:雙城之戰》動畫第二季原聲》／環球國際唱片股份有限公司（演唱者：陳奕迅／作曲人：鄭楠(SBMS)／作詞人：呂易秋(SBMS)）",
                    "winner": false
                  },
                  {
                    "text": "足芳足芳《Suí 水》／果核音樂玫瑰森林農場有限公司（演唱者：李竺芯／作曲人：李竺芯、台南歐力桑／作詞人：李竺芯）",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳華語專輯獎",
                "items": [
                  {
                    "text": "不完全自救手冊／十一音像有限公司（十一音樂）﹙演唱者：陳建騏、陳綺貞、陳珊妮、曾國宏 (落日飛車)、荒井十一、洪佩瑜、HUSH、黃綺珊、Ice Paper、JIHU、KAFE.HU 咖啡胡、康士坦的變化球、李吉吉 (Project Ace)、李銖銜 James Lee、林憶蓮、裘德、秦四風、蘇運瑩、三隻狗、圖靈音樂實驗室、Von Citizen、王OK、王菀之、王心凌、五月天瑪莎、許鈞、鄭楠、張羽涵 Leezi、周雲蓬﹚",
                    "winner": false
                  },
                  {
                    "text": "OUTCOMES 結果論／台灣索尼音樂娛樂股份有限公司﹙演唱者：J.Sheon﹚",
                    "winner": false
                  },
                  {
                    "text": "隱形色／亞神音樂娛樂股份有限公司﹙演唱者：林家謙﹚",
                    "winner": false
                  },
                  {
                    "text": "夢想家／香港商賦音樂有限公司﹙演唱者：方大同﹚",
                    "winner": false
                  },
                  {
                    "text": "好聲豪氣／任意門娛樂股份有限公司﹙演唱者：呂士軒﹚",
                    "winner": true
                  },
                  {
                    "text": "珍珠刑／何樂音樂有限公司﹙演唱者：魏如萱﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳台語專輯獎",
                "items": [
                  {
                    "text": "像咱這款人／典選音樂事業股份有限公司﹙演唱者：楊肅浩﹚",
                    "winner": false
                  },
                  {
                    "text": "物件，所在／麟鑫實業有限公司﹙演唱者：FunkyMo﹚",
                    "winner": false
                  },
                  {
                    "text": "罐頭塔／持之音股份有限公司﹙演唱者：陳以恆﹚",
                    "winner": false
                  },
                  {
                    "text": "偏南／三川娛樂有限公司﹙演唱者：謝銘祐﹚",
                    "winner": false
                  },
                  {
                    "text": "滴滴答答／傻皮文創有限公司﹙演唱者：王彙筑﹚",
                    "winner": false
                  },
                  {
                    "text": "Suí 水／果核音樂玫瑰森林農場有限公司﹙演唱者：李竺芯﹚",
                    "winner": true
                  }
                ]
              },
              {
                "title": "最佳客語專輯獎",
                "items": [
                  {
                    "text": "夢裡夢外／禾廣娛樂股份有限公司﹙演唱者：秋林﹚",
                    "winner": false
                  },
                  {
                    "text": "純粹污垢／火氣音樂股份有限公司﹙演唱者：粹垢TRAEGO﹚",
                    "winner": false
                  },
                  {
                    "text": "牛騷 New Soul／子皿有限公司﹙演唱者：黃子軒﹚",
                    "winner": true
                  },
                  {
                    "text": "𠊎个房間／黎歐創意有限公司﹙演唱者：羅思容、米莎、楊淑喻（吉那）、邱淑蟬﹚",
                    "winner": false
                  },
                  {
                    "text": "洄游／山狗大樂團﹙演唱者：林鈺婷﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳原住民語專輯獎",
                "items": [
                  {
                    "text": "雲就要翻過山／街聲股份有限公司﹙演唱者：張淦勛 Giyu Tjuljaviya﹚",
                    "winner": false
                  },
                  {
                    "text": "kamawan za kavung 像帽子一樣／野聲音樂文化事業有限公司﹙演唱者：Morikilr 孔亞明﹚",
                    "winner": false
                  },
                  {
                    "text": "QUEENDOM／華納國際音樂股份有限公司﹙演唱者：阿布絲・塔娜比瑪﹚",
                    "winner": false
                  },
                  {
                    "text": "Qrasun 格拉孫／自在合作行﹙演唱者：Kumu Basaw 姑慕·巴紹﹚",
                    "winner": false
                  },
                  {
                    "text": "mudalrep 靠近／卡達德邦文化工作室﹙演唱者：桑布伊﹚",
                    "winner": false
                  },
                  {
                    "text": "VAIVAIK 尋走／風潮音樂國際股份有限公司﹙演唱者：戴曉君 Sauljaljui﹚",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "演唱類 - 個人獎",
            "titles": [
              {
                "title": "最佳作曲人獎",
                "items": [
                  {
                    "text": "JUD 陳泳希／知更《JUD 陳泳希 首張迷你專輯》／華研國際音樂股份有限公司﹙演唱者：JUD 陳泳希﹚",
                    "winner": false
                  },
                  {
                    "text": "FunkyMo／修理車《物件，所在》／麟鑫實業有限公司﹙演唱者：FunkyMo﹚",
                    "winner": false
                  },
                  {
                    "text": "王彙筑／高麗菜粥 Feat. 洪佩瑜《滴滴答答》／傻皮文創有限公司﹙演唱者：王彙筑、洪佩瑜﹚",
                    "winner": false
                  },
                  {
                    "text": "林家謙／有色眼鏡《隱形色》／亞神音樂娛樂股份有限公司﹙演唱者：林家謙﹚",
                    "winner": false
                  },
                  {
                    "text": "方大同／才二十三《夢想家》／香港商賦音樂有限公司﹙演唱者：方大同﹚",
                    "winner": true
                  },
                  {
                    "text": "Joanna Wang／鬼才出道《《鬼才之道》電影原聲帶》／台灣索尼音樂娛樂股份有限公司﹙演唱者：王若琳﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳作詞人獎",
                "items": [
                  {
                    "text": "張淦勛 Giyu Tjuljaviya／南迴之子《雲就要翻過山》／街聲股份有限公司﹙演唱者：張淦勛 Giyu Tjuljaviya﹚",
                    "winner": true
                  },
                  {
                    "text": "李格弟／允許萬物破碎《允許萬物破碎》／台灣索尼音樂娛樂股份有限公司﹙演唱者：柏霖PoLin﹚",
                    "winner": false
                  },
                  {
                    "text": "謝銘祐／偏南風《偏南》／三川娛樂有限公司﹙演唱者：謝銘祐﹚",
                    "winner": false
                  },
                  {
                    "text": "林夕／有色眼鏡《隱形色》／亞神音樂娛樂股份有限公司﹙演唱者：林家謙﹚",
                    "winner": false
                  },
                  {
                    "text": "方大同／才二十三《夢想家》／香港商賦音樂有限公司﹙演唱者：方大同﹚",
                    "winner": false
                  },
                  {
                    "text": "李竺芯／足芳足芳《Suí 水》／果核音樂玫瑰森林農場有限公司﹙演唱者：李竺芯﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳編曲人獎",
                "items": [
                  {
                    "text": "張少瑜／BUNUN 布農《QUEENDOM》／華納國際音樂股份有限公司﹙演唱者：阿布絲・塔娜比瑪﹚",
                    "winner": false
                  },
                  {
                    "text": "Ray Lin 林啟安／Qrasun 讚美《Qrasun 格拉孫》／自在合作行﹙演唱者：Kumu Basaw 姑慕·巴紹、Ray Lin﹚",
                    "winner": false
                  },
                  {
                    "text": "鍾興民／靠近 mudalrep《mudalrep 靠近》／卡達德邦文化工作室﹙演唱者：桑布伊﹚",
                    "winner": false
                  },
                  {
                    "text": "戴曉君 Sauljaljui、吳蒙惠／Dipin Kari Tang 麵包 咖哩 刺蝟 (feat. 泰武古謠傳唱)《VAIVAIK 尋走》／風潮音樂國際股份有限公司﹙演唱者：戴曉君 Sauljaljui、泰武古謠傳唱﹚",
                    "winner": true
                  },
                  {
                    "text": "呂尚霖／二周目《好聲豪氣》／任意門娛樂股份有限公司﹙演唱者：呂士軒﹚",
                    "winner": false
                  },
                  {
                    "text": "Joanna Wang、Asher Fulero、Peter Knudsen、Bill Athens、Micah Kassell、高杰 J Geddes／鬼才出道《《鬼才之道》電影原聲帶》／台灣索尼音樂娛樂股份有限公司﹙演唱者：王若琳﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳專輯製作人獎",
                "items": [
                  {
                    "text": "高潮（林志仁）／雲就要翻過山／街聲股份有限公司﹙演唱者：張淦勛 Giyu Tjuljaviya﹚",
                    "winner": true
                  },
                  {
                    "text": "王治平／當我不敢說／華研國際音樂股份有限公司﹙演唱者：JUD 陳泳希﹚",
                    "winner": false
                  },
                  {
                    "text": "OHHYUK 오혁 (吳赫)、曾國宏／AAA／夕陽音樂產業有限公司﹙演唱者：AAA (HYUKOH & 落日飛車)﹚",
                    "winner": false
                  },
                  {
                    "text": "林家謙／隱形色／亞神音樂娛樂股份有限公司﹙演唱者：林家謙﹚",
                    "winner": false
                  },
                  {
                    "text": "呂尚霖、呂士軒／好聲豪氣／任意門娛樂股份有限公司﹙演唱者：呂士軒﹚",
                    "winner": false
                  },
                  {
                    "text": "鍾興民、李竺芯／Suí 水／果核音樂玫瑰森林農場有限公司﹙演唱者：李竺芯﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳單曲製作人獎",
                "items": [
                  {
                    "text": "陳建瑋／皇民戰士大軍伕《像咱這款人》／典選音樂事業股份有限公司﹙演唱者：楊肅浩﹚",
                    "winner": false
                  },
                  {
                    "text": "海大富／BUNUN 布農《QUEENDOM》／華納國際音樂股份有限公司﹙演唱者：阿布絲・塔娜比瑪﹚",
                    "winner": true
                  },
                  {
                    "text": "于傳勇、金智湖／COCOCO《1st Single Album COCOCO》／天空娛樂股份有限公司﹙演唱者：GENBLUE幻藍小熊﹚",
                    "winner": false
                  },
                  {
                    "text": "鍾興民／靠近 mudalrep《mudalrep 靠近》／卡達德邦文化工作室﹙演唱者：桑布伊﹚",
                    "winner": false
                  },
                  {
                    "text": "柯智豪 Blaire Ko／臺灣文蛤 Huh?《臺灣文蛤 Huh?》／創銘實業股份有限公司﹙演唱者：A_Root同根生﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳華語男歌手獎",
                "items": [
                  {
                    "text": "柏霖PoLin／允許萬物破碎／台灣索尼音樂娛樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "蕭煌奇／沒事的／華納國際音樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "林家謙／隱形色／亞神音樂娛樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "呂士軒／好聲豪氣／任意門娛樂股份有限公司",
                    "winner": true
                  },
                  {
                    "text": "李榮浩／黑馬／台灣索尼音樂娛樂股份有限公司",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳華語女歌手獎",
                "items": [
                  {
                    "text": "蔡健雅／不夠善良的我們：戲劇音樂設計專輯／亞神音樂娛樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "戴佩妮 Penny Tai／雙生火焰 TWIN FLAME／薩摩亞商妮樂佛創意有限公司台灣分公司",
                    "winner": false
                  },
                  {
                    "text": "陳忻玥／V／史科特音樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "Karencici／Made For You／華納國際音樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "魏如萱／珍珠刑／何樂音樂有限公司",
                    "winner": true
                  }
                ]
              },
              {
                "title": "最佳台語男歌手獎",
                "items": [
                  {
                    "text": "楊肅浩／像咱這款人／典選音樂事業股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "FunkyMo／物件，所在／麟鑫實業有限公司",
                    "winner": false
                  },
                  {
                    "text": "陳以恆／罐頭塔／持之音股份有限公司",
                    "winner": true
                  },
                  {
                    "text": "謝銘祐／偏南／三川娛樂有限公司",
                    "winner": false
                  },
                  {
                    "text": "馬克SAVAGE.M／海口／晚安島音樂娛樂有限公司",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳台語女歌手獎",
                "items": [
                  {
                    "text": "蔡秋鳳 Carris Tsai／戲台／創銘實業股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "林美秀／Lady Pum Pum／三川娛樂有限公司",
                    "winner": false
                  },
                  {
                    "text": "王彙筑／滴滴答答／傻皮文創有限公司",
                    "winner": false
                  },
                  {
                    "text": "李竺芯／Suí 水／果核音樂玫瑰森林農場有限公司",
                    "winner": true
                  },
                  {
                    "text": "詹雅雯／演一首歌／雅雯音樂工作室有限公司",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳客語歌手獎",
                "items": [
                  {
                    "text": "秋林／夢裡夢外／禾廣娛樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "粹垢／純粹污垢／火氣音樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "黃子軒／牛騷 New Soul／子皿有限公司",
                    "winner": true
                  },
                  {
                    "text": "米莎／親愛的企鵝／老頭音樂",
                    "winner": false
                  },
                  {
                    "text": "林鈺婷／洄游／山狗大樂團",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳原住民語歌手獎",
                "items": [
                  {
                    "text": "Morikilr 孔亞明／kamawan za kavung 像帽子一樣／野聲音樂文化事業有限公司",
                    "winner": false
                  },
                  {
                    "text": "阿布絲・塔娜比瑪／QUEENDOM／華納國際音樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "Kumu Basaw 姑慕·巴紹／Qrasun 格拉孫／自在合作行",
                    "winner": true
                  },
                  {
                    "text": "桑布伊／mudalrep 靠近／卡達德邦文化工作室",
                    "winner": false
                  },
                  {
                    "text": "戴曉君 Sauljaljui／VAIVAIK 尋走／風潮音樂國際股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "曾妮 Dremedreman／全村的希望／那屋瓦文化有限公司",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳樂團獎",
                "items": [
                  {
                    "text": "無妄合作社／開往天堂的海盜船／空氣腦唱片有限公司",
                    "winner": false
                  },
                  {
                    "text": "JADE（嘟嘟、AJ）／Creeper／多好娛樂事業有限公司",
                    "winner": false
                  },
                  {
                    "text": "美秀集團（鍾錡、修齊、冠佑、婷文、狗柏）／美秀集團同名專輯／火玄火包股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "TRASH（頤原、博文、魁剛、阿夜）／幸福的末班車／華納國際音樂股份有限公司",
                    "winner": true
                  },
                  {
                    "text": "AAA (HYUKOH & 落日飛車)（曾國宏、OHHYUK 오혁 (吳赫)、陳弘禮、Im Dong Gun 임동건 (任童健)、Lim Hyun Jae 임현제 (林賢帝)、王少軒、JNKYRD 권성철、羅尊龍、Lee In Woo 이인우 (李仁雨)、黃浩庭）／AAA／夕陽音樂產業有限公司",
                    "winner": false
                  },
                  {
                    "text": "八十八顆芭樂籽（李奇明、李敘忻、陳冠伶、李東祐）／浪漫野球戰士列傳／共勉之股份有限公司",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳演唱組合獎",
                "items": [
                  {
                    "text": "恐龍的皮（暴龍、三角龍）／I Dig You／銀翼文創有限公司",
                    "winner": false
                  },
                  {
                    "text": "動力火車（尤秋興、顏志琳）／結伴(豪華版)／華研國際音樂股份有限公司",
                    "winner": true
                  },
                  {
                    "text": "Energy（葉乃文、張書偉、郭葦昀、謝坤達、蕭景鴻）／Here I Am／相信音樂國際股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "珂拉琪（夏子、王家權）／Deus Ex Machina／寫在邊緣有限公司",
                    "winner": false
                  },
                  {
                    "text": "丹丹猫猫 = aDAN薛詒丹 x Miao Miao Flow（aDAN薛詒丹、Miao Miao Flow）／RUN, DON'T WALK／跪著聽音樂有限公司",
                    "winner": false
                  },
                  {
                    "text": "ATARASHII GAKKO!（Mizyu、Rin、Suzuka、Kanon）／AG! Calling／台灣索尼音樂娛樂股份有限公司",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳新人獎",
                "items": [
                  {
                    "text": "鄭雙雙／Time／聲音的卡夫卡股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "張淦勛 Giyu Tjuljaviya／雲就要翻過山／街聲股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "someshiit 山姆／愚公／滾石移動股份有限公司",
                    "winner": true
                  },
                  {
                    "text": "JUD 陳泳希／當我不敢說／華研國際音樂股份有限公司",
                    "winner": false
                  },
                  {
                    "text": "Kumu Basaw 姑慕·巴紹／Qrasun 格拉孫／自在合作行",
                    "winner": false
                  },
                  {
                    "text": "Andr／shhh, it’s under my bed／福祿壽音樂娛樂有限公司",
                    "winner": false
                  }
                ]
              }
            ]
          },
          {
            "category": "演奏類 - 出版獎",
            "titles": [
              {
                "title": "演奏類最佳專輯獎",
                "items": [
                  {
                    "text": "OR 手術劇院／好有感覺音樂事業有限公司﹙演奏者：楊又臻爵士大樂團﹚",
                    "winner": false
                  },
                  {
                    "text": "練習曲／就是現場股份有限公司﹙演奏者：張貝芝﹚",
                    "winner": true
                  },
                  {
                    "text": "胎內／東城音樂製作有限公司﹙演奏者：呂紹淳﹚",
                    "winner": false
                  },
                  {
                    "text": "世間／宏揚國際有限公司﹙演奏者：覺者﹚",
                    "winner": false
                  },
                  {
                    "text": "青雲之上／果核音樂玫瑰森林農場有限公司﹙演奏者：鍾興民﹚",
                    "winner": false
                  }
                ]
              }
            ]
          },
          {
            "category": "演奏類 - 個人獎",
            "titles": [
              {
                "title": "演奏類最佳專輯製作人獎",
                "items": [
                  {
                    "text": "程杰／甘 Aftertaste／王思雅音樂工作室﹙演奏者：Debby Wang 王思雅﹚",
                    "winner": false
                  },
                  {
                    "text": "張貝芝／練習曲／就是現場股份有限公司﹙演奏者：張貝芝﹚",
                    "winner": false
                  },
                  {
                    "text": "蘇紫旭、安志華／以空／宏揚國際有限公司﹙演奏者：以空、蘇紫旭、安志華﹚",
                    "winner": true
                  },
                  {
                    "text": "呂紹淳／胎內／東城音樂製作有限公司﹙演奏者：呂紹淳﹚",
                    "winner": false
                  },
                  {
                    "text": "蔡曜宇／憶聲弦命 滾石40【40首OST 致經典】 滾石影視主題曲演奏專輯／滾石國際音樂股份有限公司﹙演奏者：曜爆甘弦樂團﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "演奏類最佳作曲人獎",
                "items": [
                  {
                    "text": "楊又臻 Tracy Yang／手術劇院《OR 手術劇院》／好有感覺音樂事業有限公司﹙演奏者：楊又臻爵士大樂團﹚",
                    "winner": false
                  },
                  {
                    "text": "湯姆·布爾喬斯／5 Flamingos《5 Flamingos》／奧尼斯音樂有限公司﹙演奏者：湯姆·布爾喬斯、郭俊育﹚",
                    "winner": false
                  },
                  {
                    "text": "張貝芝／Étude No.1 in D - Carpark《練習曲》／就是現場股份有限公司﹙演奏者：張貝芝、李駿銚、曾浩威、崔展鴻、黎逸晞、陳駿軒﹚",
                    "winner": false
                  },
                  {
                    "text": "翁曲弦、蘇紫旭、安志華、韓舒凡／鳶飛《以空》／宏揚國際有限公司﹙演奏者：以空、蘇紫旭、安志華﹚",
                    "winner": false
                  },
                  {
                    "text": "王育嘉、簡聿民、林均憲／參螺旋《幾何碼》／數日子音樂工作室﹙演奏者：幾何碼﹚",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "技術類 - 個人獎",
            "titles": [
              {
                "title": "最佳裝幀設計獎",
                "items": [
                  {
                    "text": "劉悅德／物件，所在／麟鑫實業有限公司",
                    "winner": false
                  },
                  {
                    "text": "于薇／王品流 Freestyle／倒吃甘蔗音樂工作室",
                    "winner": false
                  },
                  {
                    "text": "吳建龍、畢展熒、蔡偉群／你在注視那遙遠的地方／三角街藝術事業有限公司",
                    "winner": false
                  },
                  {
                    "text": "黃家賢、葉昶利／Jug Band Millionaire／泥灘地浪人音樂工作室",
                    "winner": false
                  },
                  {
                    "text": "Chanhee Hong、Na Kim／AAA／夕陽音樂產業有限公司",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "技術類 - 出版獎",
            "titles": [
              {
                "title": "最佳演唱錄音專輯獎",
                "items": [
                  {
                    "text": "My Nova／ 銀翼文創有限公司  （主要錄音人員：林尚伯、高勤倫、朱品豪、陳以霖、蔡周翰／主要混音人員：王昱辰、黃文萱、沈冠霖、陳君豪／主要母帶後製人員：Alex Wharton）",
                    "winner": false
                  },
                  {
                    "text": "Creeper／ 多好娛樂事業有限公司  （主要錄音人員：蔡周翰、嘟嘟、邱建鈞、錢煒安、莊鈞智／主要混音人員：周已敦／主要母帶後製人員：周已敦）",
                    "winner": false
                  },
                  {
                    "text": "南洋探險隊／ 浮氣音樂有限公司  （主要錄音人員：徐振程、錢煒安、陳祺龍、陳逸宏、陳以霖、蔡周翰、朱品豪、Audry Garcia Dionsio、雷擎／主要混音人員：徐振程、錢煒安、陳祺龍、林漢庭、黃文萱／主要母帶後製人員：Alex Wharton）",
                    "winner": false
                  },
                  {
                    "text": "AAA／ 夕陽音樂產業有限公司  （主要錄音人員：SangHyun Cho、HyeSeok Oh、王昱辰、YJ (Moollon)、劉先彬／主要混音人員：Norman Nitzsche／主要母帶後製人員：Norman Nitzsche）",
                    "winner": true
                  },
                  {
                    "text": "珍珠刑／ 何樂音樂有限公司  （主要錄音人員：陳以霖、錢煒安、于世政、林尚伯、蔡周翰、朱品豪、于京延／主要混音人員：Wayson Scream、黃少雍、Simon Li、莊鈞智、黃文萱、林正忠、陳君豪／主要母帶後製人員：Wayson Scream）",
                    "winner": false
                  },
                  {
                    "text": "VILLAIN 反派角色／ 台灣索尼音樂娛樂股份有限公司  （主要錄音人員：Chace、Alice／主要混音人員：Chace／主要母帶後製人員：Chace）",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳演奏錄音專輯獎",
                "items": [
                  {
                    "text": "OR 手術劇院／ 好有感覺音樂事業有限公司  （主要錄音人員：Brian Montgomery／主要混音人員：Brian Montgomery／主要母帶後製人員：Mark Wilder）",
                    "winner": true
                  },
                  {
                    "text": "甘 Aftertaste／ 王思雅音樂工作室  （主要錄音人員：蔡周翰／主要混音人員：程杰／主要母帶後製人員：Zino Mikorey）",
                    "winner": false
                  },
                  {
                    "text": "練習曲／ 就是現場股份有限公司  （主要錄音人員：單為明、于世政、陳佳穎／主要混音人員：單為明／主要母帶後製人員：Jeff Lipton、Maria Rice、Costanza Tinti）",
                    "winner": false
                  },
                  {
                    "text": "7 Seven／ 台灣索尼音樂娛樂股份有限公司  （主要錄音人員：李遊、張宇涵、李楊／主要混音人員：李遊／主要母帶後製人員：李遊）",
                    "winner": false
                  },
                  {
                    "text": "Ctrl+Z／ 明天的歌有限公司  （主要錄音人員：蔡周翰／主要混音人員：程杰、陳君豪、符家寶／主要母帶後製人員：Jeff Lipton）",
                    "winner": false
                  }
                ]
              },
              {
                "title": "最佳MV獎",
                "items": [
                  {
                    "text": "Antenna《AAA》／夕陽音樂產業有限公司﹙導演：rafhoo﹚ ",
                    "winner": true
                  },
                  {
                    "text": "Young Man《AAA》／夕陽音樂產業有限公司﹙導演：Pennacky﹚ ",
                    "winner": false
                  },
                  {
                    "text": "基礎憂鬱《且且》／夜間限定有限公司﹙導演：自動鮪魚﹚ ",
                    "winner": false
                  },
                  {
                    "text": "Dab Hi《Dab Hi》／貳參有限公司﹙導演：陳則安﹚ ",
                    "winner": false
                  },
                  {
                    "text": "可夢《髒藝術家》／滾石國際音樂股份有限公司﹙導演：林宏叡 Reago﹚ ",
                    "winner": false
                  },
                  {
                    "text": "Buzz《Buzz》／台灣索尼音樂娛樂股份有限公司﹙導演：Isaac Ravishankara﹚ ",
                    "winner": false
                  }
                ]
              }
            ]
          },
          {
            "category": "評審團獎",
            "titles": [
              {
                "title": "評審團獎",
                "items": [
                  {
                    "text": "方大同 夢想家專輯 ",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "特別貢獻獎",
            "titles": [
              {
                "title": "特別貢獻獎",
                "items": [
                  {
                    "text": "翁孝良",
                    "winner": true
                  },
                  {
                    "text": "馬兆駿",
                    "winner": true
                  }
                ]
              }
            ]
          }
        ]
      };
    } else {
      this.AwardWinnersData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "AwardWinners_Name": "Nomination",
        "AwardWinners_Menu": [
          {
            "category": "Vocal - Record Label Awards",
            "titles": [
              {
                "title": "Album of the Year",
                "items": [
                  {
                    "text": "Best Mandarin Album Nominees",
                    "winner": false
                  },
                  {
                    "text": "Best Taiwanese Album Nominees",
                    "winner": false
                  },
                  {
                    "text": "Best Hakka Album Nominees",
                    "winner": false
                  },
                  {
                    "text": "Best Indigenous Language Album Nominees",
                    "winner": false
                  },
                  {
                    "text": "Suí／GoAhead Music Rose Farm and Forest Co., Ltd.﹙Performed by：Siri Lee﹚",
                    "winner": true
                  }
                ]
              },
              {
                "title": "Song of the Year",
                "items": [
                  {
                    "text": "BUNUN《QUEENDOM》／Warner Music Taiwan Ltd.（Performed by：Abus・Tanapima／Composer：Abus、Charles Chang／Lyricist：Abus）",
                    "winner": false
                  },
                  {
                    "text": "Phone, Wallet, Keys, Cigarettes feat. Crowd Lu《Amazing Show》／AmazingShow Co., LTD.（Performed by：Amazing Show、Crowd Lu／Composer：Hsiu Liu、Crowd Lu／Lyricist：Hsiu Liu、Crowd Lu）",
                    "winner": false
                  },
                  {
                    "text": "phian-lâm-hong《phian-lâm》／KAWA Music Co.Ltd（Performed by：Ming-Yo Hsieh／Composer：Ming-Yo Hsieh／Lyricist：Ming-Yo Hsieh）",
                    "winner": false
                  },
                  {
                    "text": "Young Man《AAA》／Sunset Music Productions Co., Ltd.（Performed by：AAA (HYUKOH & Sunset Rollercoaster)／Composer：OHHYUK、TSENG KUO HUNG／Lyricist：OHHYUK、JNKYRD、TSENG KUO HUNG）",
                    "winner": false
                  },
                  {
                    "text": "Friday Night《Here I Am》／B'in Music（Performed by：Energy／Composer：Oliver Kim、Alex Chang Jien／Lyricist：Ho Yu-shen、Chih Jen、Oliver Kim）",
                    "winner": true
                  },
                  {
                    "text": "Twenty Three《The Dreamer》／FU MUSIC LIMITED（Performed by：Khalil Fong／Composer：Khalil Fong／Lyricist：Khalil Fong）",
                    "winner": false
                  },
                  {
                    "text": "Isha's Song (from the series Arcane: League of Legends)《Isha's Song (from the series Arcane: League of Legends)》／Universal Music Limited（Performed by：Eason Chan／Composer：Zheng Nan(SBMS)／Lyricist：Lyu Yiqiu (SBMS)）",
                    "winner": false
                  },
                  {
                    "text": "Je prends, je prends. Je vais voir.《Suí》／GoAhead Music Rose Farm and Forest Co., Ltd.（Performed by：Siri Lee／Composer：Siri Lee、Uncle Tainan／Lyricist：Siri Lee）",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Mandarin Album",
                "items": [
                  {
                    "text": "Incomplete Rescue Manual／ELEVENZ PRODUCTION & PUBLISHING CO., LTD.﹙Performed by：George Chen、Cheer Chen、Sandee Chan、Kuo-Hung Tseng、araiz、Pei-Yu Hung、HUSH、Sophia Huang、Ice Paper、JIHU、KAFE.HU、KST、Ji Ji Lee(Project Ace)、James Lee、Sandy Lam、Jude Chiu、Sedar Chin、Sue、3 Dogs、TML、Von Citizen、WANG OK、Ivana Wong、Cyndi Wang、Mayday Masa、Xu Jun、Nan、Leezi、Yun Peng Zhou﹚",
                    "winner": false
                  },
                  {
                    "text": "OUTCOMES／Sony Music Entertainment Taiwan Ltd.﹙Performed by：J.Sheon﹚",
                    "winner": false
                  },
                  {
                    "text": "CAMOUFLAGE／AsiaMuse Entertainment Co., Ltd.﹙Performed by：Terence Lam﹚",
                    "winner": false
                  },
                  {
                    "text": "The Dreamer／FU MUSIC LIMITED﹙Performed by：Khalil Fong﹚",
                    "winner": false
                  },
                  {
                    "text": "GOOD SOUND WITH ATTITUDES／RYM Entertainment Co.,Ltd.﹙Performed by：TroutFresh﹚",
                    "winner": true
                  },
                  {
                    "text": "Ordeal by Pearls／POURQUOI PAS MUSIC LIMITED﹙Performed by：waa wei﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Taiwanese Album",
                "items": [
                  {
                    "text": "People like us／Click Music Co., Ltd.﹙Performed by：Su-hao Yang﹚",
                    "winner": false
                  },
                  {
                    "text": "People, Places, Things／Lyncean Development Co., Ltd.﹙Performed by：FunkyMo﹚",
                    "winner": false
                  },
                  {
                    "text": "can cancan cancancan／Tetera inc.﹙Performed by：Chen Yi Heng﹚",
                    "winner": false
                  },
                  {
                    "text": "phian-lâm／KAWA Music Co.Ltd﹙Performed by：Ming-Yo Hsieh﹚",
                    "winner": false
                  },
                  {
                    "text": "Drip-Drop／Sappy Studio﹙Performed by：Hui Chu Wang﹚",
                    "winner": false
                  },
                  {
                    "text": "Suí／GoAhead Music Rose Farm and Forest Co., Ltd.﹙Performed by：Siri Lee﹚",
                    "winner": true
                  }
                ]
              },
              {
                "title": "Best Hakka Album",
                "items": [
                  {
                    "text": "In and Out of Dreams／Ho Vision Entertainment Co., Ltd﹙Performed by：Aringu﹚",
                    "winner": false
                  },
                  {
                    "text": "Pure Filth／Fire On Music﹙Performed by：TRAEGO﹚",
                    "winner": false
                  },
                  {
                    "text": "New Soul／In Utero Ltd.﹙Performed by：ZiXuan Huang﹚",
                    "winner": true
                  },
                  {
                    "text": "The women’s voice／LEO VISION COMMUNICATION DESIGN LTD.﹙Performed by：Lo Ssu-Jung, Misa, Yang Shu-Yu, and Chiu Shu-Chan﹚",
                    "winner": false
                  },
                  {
                    "text": "Upstream／San Geu Tai Band﹙Performed by：Rita Lin﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Indigenous Language Album",
                "items": [
                  {
                    "text": "Upstream／San Geu Tai Band﹙Performed by：Rita Lin﹚",
                    "winner": false
                  },
                  {
                    "text": "kamawan za kavung／Uti Music Ltd.﹙Performed by：Morikilr﹚",
                    "winner": false
                  },
                  {
                    "text": "QUEENDOM／Warner Music Taiwan Ltd.﹙Performed by：Abus・Tanapima﹚",
                    "winner": false
                  },
                  {
                    "text": "Qrasun／TAO DAO Ltd.﹙Performed by：Kumu Basaw﹚",
                    "winner": false
                  },
                  {
                    "text": "Draw Near／Katatepan Cultural Studio﹙Performed by：SANGPUY﹚",
                    "winner": false
                  },
                  {
                    "text": "VAIVAIK／WIND MUSIC International Corporation﹙Performed by：Sauljaljui﹚",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "Vocal - Individual Awards",
            "titles": [
              {
                "title": "Best Composer",
                "items": [
                  {
                    "text": "JUD／Redbreast《JUD 1st EP》／HIM International Music Inc.﹙Performed by：JUD﹚",
                    "winner": false
                  },
                  {
                    "text": "FunkyMo／Carfix《People, Places, Things》／Lyncean Development Co., Ltd.﹙Performed by：FunkyMo﹚",
                    "winner": false
                  },
                  {
                    "text": "Hui Chu Wang／Cabbage Congee《Drip-Drop》／Sappy Studio﹙Performed by：Hui Chu Wang、Pei-Yu Hung﹚",
                    "winner": false
                  },
                  {
                    "text": "Terence Lam／Shade《CAMOUFLAGE》／AsiaMuse Entertainment Co., Ltd.﹙Performed by：Terence Lam﹚",
                    "winner": false
                  },
                  {
                    "text": "Khalil Fong／Twenty Three《The Dreamer》／FU MUSIC LIMITED﹙Performed by：Khalil Fong﹚",
                    "winner": true
                  },
                  {
                    "text": "Joanna Wang／Dead Talents Society《Dead Talents Society (Original Soundtrack)》／Sony Music Entertainment Taiwan Ltd.﹙Performed by：Joanna Wang﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Lyricist",
                "items": [
                  {
                    "text": "Giyu Tjuljaviya／Child of the South Link (Home to Home)《The Wind that Found Me》／STREETVOICE (TAIWAN) CO., LTD﹙Performed by：Giyu Tjuljaviya﹚",
                    "winner": true
                  },
                  {
                    "text": "Katie Lee／Fragments of Becoming《Fragments of Becoming》／Sony Music Entertainment Taiwan Ltd.﹙Performed by：PoLin Tung﹚",
                    "winner": false
                  },
                  {
                    "text": "Ming-Yo Hsieh／phian-lâm-hong《phian-lâm》／KAWA Music Co.Ltd﹙Performed by：Ming-Yo Hsieh﹚",
                    "winner": false
                  },
                  {
                    "text": "Lin Xi／Shade《CAMOUFLAGE》／AsiaMuse Entertainment Co., Ltd.﹙Performed by：Terence Lam﹚",
                    "winner": false
                  },
                  {
                    "text": "Khalil Fong／Twenty Three《The Dreamer》／FU MUSIC LIMITED﹙Performed by：Khalil Fong﹚",
                    "winner": false
                  },
                  {
                    "text": "Siri Lee／Je prends, je prends. Je vais voir.《Suí》／GoAhead Music Rose Farm and Forest Co., Ltd.﹙Performed by：Siri Lee﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Arranger",
                "items": [
                  {
                    "text": "Charles Chang／BUNUN《QUEENDOM》／Warner Music Taiwan Ltd.﹙Performed by：Abus・Tanapima﹚",
                    "winner": false
                  },
                  {
                    "text": "Ray Lin／Praise《Qrasun》／TAO DAO Ltd.﹙Performed by：Kumu Basaw、Ray Lin﹚",
                    "winner": false
                  },
                  {
                    "text": "Baby-C／Draw near《Draw Near》／Katatepan Cultural Studio﹙Performed by：SANGPUY﹚",
                    "winner": false
                  },
                  {
                    "text": "Sauljaljui、Vikung Ruljadeng／Dipin Kari Tang (feat. Taiwu Ballads Troupe)《VAIVAIK》／WIND MUSIC International Corporation﹙Performed by：Sauljaljui、Taiwu Ballads Troupe﹚",
                    "winner": true
                  },
                  {
                    "text": "LuuX／New Game +《GOOD SOUND WITH ATTITUDES》／RYM Entertainment Co.,Ltd.﹙Performed by：Trout Fresh﹚",
                    "winner": false
                  },
                  {
                    "text": "Joanna Wang、Asher Fulero、Peter Knudsen、Bill Athens、Micah Kassell、J Geddes／Dead Talents Society《Dead Talents Society (Original Soundtrack)》／Sony Music Entertainment Taiwan Ltd.﹙Performed by：Joanna Wang﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Album Producer",
                "items": [
                  {
                    "text": "CJ Hightide／The Wind that Found Me／STREETVOICE (TAIWAN) CO., LTD﹙Performed by：Giyu Tjuljaviya﹚",
                    "winner": true
                  },
                  {
                    "text": "Bing Wang／Weak Messages Create Bad Situations／HIM International Music Inc.﹙Performed by：JUD﹚",
                    "winner": false
                  },
                  {
                    "text": "OHHYUK、TSENG KUO HUNG／AAA／Sunset Music Productions Co., Ltd.﹙Performed by：AAA (HYUKOH & Sunset Rollercoaster)﹚",
                    "winner": false
                  },
                  {
                    "text": "Terence Lam／CAMOUFLAGE／AsiaMuse Entertainment Co., Ltd.﹙Performed by：Terence Lam﹚",
                    "winner": false
                  },
                  {
                    "text": "LuuX、Trout Fresh／GOOD SOUND WITH ATTITUDES／RYM Entertainment Co.,Ltd.﹙Performed by：TroutFresh﹚",
                    "winner": false
                  },
                  {
                    "text": "Baby-C、Siri Lee／Suí／GoAhead Music Rose Farm and Forest Co., Ltd.﹙Performed by：Siri Lee﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Song Producer",
                "items": [
                  {
                    "text": "Jacky Chen／Taiwanese Imperial Serviceman《People like us》／Click Music Co., Ltd.﹙Performed by：Su-hao Yang﹚",
                    "winner": false
                  },
                  {
                    "text": "Déjà Fu／BUNUN《QUEENDOM》／Warner Music Taiwan Ltd.﹙Performed by：Abus・Tanapima﹚",
                    "winner": true
                  },
                  {
                    "text": "WOO.K、KIM JIHO／COCOCO《1st Single Album COCOCO》／TEN ENTERTAINMENT CO., LTD.﹙Performed by：GENBLUE (젠블루)﹚",
                    "winner": false
                  },
                  {
                    "text": "Baby-C／Draw near《Draw Near》／Katatepan Cultural Studio﹙Performed by：SANGPUY﹚",
                    "winner": false
                  },
                  {
                    "text": "Blaire Ko／Huh?《Huh?》／Blaire Ko Music Studio﹙Performed by：A_Root﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Male Singer （Mandarin）",
                "items": [
                  {
                    "text": "PoLin Tung／Fragments of Becoming／Sony Music Entertainment Taiwan Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Ricky Hsiao／No Worries／Warner Music Taiwan Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Terence Lam／CAMOUFLAGE／AsiaMuse Entertainment Co., Ltd.",
                    "winner": false
                  },
                  {
                    "text": "TroutFresh／GOOD SOUND WITH ATTITUDES／RYM Entertainment Co.,Ltd.",
                    "winner": true
                  },
                  {
                    "text": "Ronghao Li／Black Horse／Sony Music Entertainment Taiwan Ltd.",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Female Singer （Mandarin）",
                "items": [
                  {
                    "text": "Tanya Chua／Imperfect Us：Original Soundtrack／AsiaMuse Entertainment Co., Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Penny Tai／TWIN FLAME／NeverFall Inc. (Taiwan Branch）",
                    "winner": false
                  },
                  {
                    "text": "Vicky Chen／V／SKR CO., LTD.",
                    "winner": false
                  },
                  {
                    "text": "Karencici／Made For You／Warner Music Taiwan Ltd.",
                    "winner": false
                  },
                  {
                    "text": "waa wei／Ordeal by Pearls／POURQUOI PAS MUSIC LIMITED",
                    "winner": true
                  }
                ]
              },
              {
                "title": "Best Male Singer （Taiwanese）",
                "items": [
                  {
                    "text": "Su-hao Yang／People like us／Click Music Co., Ltd.",
                    "winner": false
                  },
                  {
                    "text": "FunkyMo／People, Places, Things／Lyncean Development Co., Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Chen Yi Heng／can cancan cancancan／Tetera inc.",
                    "winner": true
                  },
                  {
                    "text": "Ming-Yo Hsieh／phian-lâm／KAWA Music Co.Ltd",
                    "winner": false
                  },
                  {
                    "text": "SAVAGE.M／hái-kháu／99island Ltd.",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Female Singer （Taiwanese）",
                "items": [
                  {
                    "text": "Carris Tsai／hì tâi／Blaire Ko Music Studio",
                    "winner": false
                  },
                  {
                    "text": "Lin Mei Hsiu／Lady Pum Pum／KAWA Music Co.Ltd",
                    "winner": false
                  },
                  {
                    "text": "Hui Chu Wang／Drip-Drop／Sappy Studio",
                    "winner": false
                  },
                  {
                    "text": "Siri Lee／Suí／GoAhead Music Rose Farm and Forest Co., Ltd.",
                    "winner": true
                  },
                  {
                    "text": "Zhan Ya Wen／Perform  a song／Ya Wen Music Studio Ltd.",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Singer （Hakka）",
                "items": [
                  {
                    "text": "Aringu／In and Out of Dreams／Ho Vision Entertainment Co., Ltd",
                    "winner": false
                  },
                  {
                    "text": "TRAEGO／Pure Filth／Fire On Music",
                    "winner": false
                  },
                  {
                    "text": "ZiXuan Huang／New Soul／In Utero Ltd.",
                    "winner": true
                  },
                  {
                    "text": "Misa Wen／Deer Penguin／Now Music Taiwan",
                    "winner": false
                  },
                  {
                    "text": "Rita Lin／Upstream／San Geu Tai Band",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Singer （Indigenous Language）",
                "items": [
                  {
                    "text": "Morikilr／kamawan za kavung／Uti Music Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Abus・Tanapima／QUEENDOM／Warner Music Taiwan Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Kumu Basaw／Qrasun／TAO DAO Ltd.",
                    "winner": true
                  },
                  {
                    "text": "SANGPUY／Draw Near／Katatepan Cultural Studio",
                    "winner": false
                  },
                  {
                    "text": "Sauljaljui／VAIVAIK／WIND MUSIC International Corporation",
                    "winner": false
                  },
                  {
                    "text": "Dremedreman／The chosen one of the village／Nanguaq Co.,Ltd",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Band",
                "items": [
                  {
                    "text": "No-nonsense Collective／The Pirate Ship Sailing to Heaven／AIRHEAD RECORDS CO., LTD.",
                    "winner": false
                  },
                  {
                    "text": "JADE: dooodooo、AJ／Creeper／HOW NICE ENTERTAINMENT CO ., LTD",
                    "winner": false
                  },
                  {
                    "text": "Amazing Show: Kenny、Hsiu Liu、Luis Khu、Jennifer、Gobo／Amazing Show／AmazingShow Co., LTD.",
                    "winner": false
                  },
                  {
                    "text": "TRASH: Euan、TTeng、Kuei gun、Marz／The Last Train of Happiness／Warner Music Taiwan Ltd.",
                    "winner": true
                  },
                  {
                    "text": "AAA (HYUKOH & SUNSET ROLLERCOASTER): TSENG KUO HUNG、OHHYUK、CHEN HUNG LI、IM DONG GUN、LIM HYUN JAE、WANG SHAO HSUAN、JNKYRD、LO TSUN LUNG、LEE IN WOO、HUANG HAO TING／AAA／Sunset Music Productions Co., Ltd.",
                    "winner": false
                  },
                  {
                    "text": "88balaz／Legend of the Romantic Baseball Warriors／GO MAN ZHI MUSIC Co.,Ltd.",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Vocal Group",
                "items": [
                  {
                    "text": "The Dinosaur's Skin: T-Rex / Triceratops／I Dig You／Mr. Wing Creative CO., LTD.",
                    "winner": false
                  },
                  {
                    "text": "Power Station: Yu-Chiu Sing、Chih-lin Yen／Always with you／HIM International Music Inc.",
                    "winner": true
                  },
                  {
                    "text": "Energy: Nick Yeh、Chang Shu-Wei、Toro WY Kuo、Kunda Hsieh、Edy Hsiao／Here I Am／B'in Music",
                    "winner": false
                  },
                  {
                    "text": "Collage（Natsuko·Lariyod、Hunter Wang）／Deus Ex Machina／Write on the Edge CO., LTD.",
                    "winner": false
                  },
                  {
                    "text": "DDMM = aDAN x Miao Miao Flow: aDAN、Miao Miao Flow／RUN, DON'T WALK／may I stand up Co., Ltd",
                    "winner": false
                  },
                  {
                    "text": "ATARASHII GAKKO!: Mizyu、Rin、Suzuka、Kanon／AG! Calling／Sony Music Entertainment Taiwan Ltd.",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best New Artist",
                "items": [
                  {
                    "text": "SherryZ／Time／KFK2020 Co., Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Giyu Tjuljaviya／The Wind that Found Me／STREETVOICE (TAIWAN) CO., LTD",
                    "winner": false
                  },
                  {
                    "text": "someshiit／A FOOL／Rock Mobile Corporation",
                    "winner": true
                  },
                  {
                    "text": "JUD／Weak Messages Create Bad Situations／HIM International Music Inc.",
                    "winner": false
                  },
                  {
                    "text": "Kumu Basaw／Qrasun／TAO DAO Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Andr／shhh, it’s under my bed／Fortune Coookie Records",
                    "winner": false
                  }
                ]
              }
            ]
          },
          {
            "category": "Instrumental - Record Label Awards",
            "titles": [
              {
                "title": "Best Instrumental Album",
                "items": [
                  {
                    "text": "OR／Feeling Good Music Co., Ltd﹙Performed by：Tracy Yang Jazz Orchestra﹚",
                    "winner": false
                  },
                  {
                    "text": "The Études／KKLIVE LIMITED﹙Performed by：Joyce Cheung﹚",
                    "winner": true
                  },
                  {
                    "text": "Tainai／EASTTOWN MUSIC PRODUCTION﹙Performed by：Lu Shao Chun﹚",
                    "winner": false
                  },
                  {
                    "text": "The Temporals／PRO PROMOTING INTERNATIONAL CO LTD﹙Performed by：JUE﹚",
                    "winner": false
                  },
                  {
                    "text": "Beyond／GoAhead Music Rose Farm and Forest Co., Ltd.﹙Performed by：Baby-C﹚",
                    "winner": false
                  }
                ]
              }
            ]
          },
          {
            "category": "Instrumental - Individual Awards",
            "titles": [
              {
                "title": "Best Instrumental Album Producer",
                "items": [
                  {
                    "text": "Jay Cheng／Aftertaste／Debby Wang Music Studio﹙Performed by：Debby Wang﹚",
                    "winner": false
                  },
                  {
                    "text": "Joyce Cheung／The Études／KKLIVE LIMITED﹙Performed by：Joyce Cheung﹚",
                    "winner": false
                  },
                  {
                    "text": "Szx.、HadiT／Eong／PRO PROMOTING INTERNATIONAL CO LTD﹙Performed by：Eong、Szx.、HadiT﹚",
                    "winner": true
                  },
                  {
                    "text": "Lu Shao Chun／Tainai／EASTTOWN MUSIC PRODUCTION﹙Performed by：Lu Shao Chun﹚",
                    "winner": false
                  },
                  {
                    "text": "Shuon Tsai／Memorable voice Liftime ROCK 40th, 40 OSTs – Salut To Classic, Best OSTs On The ROCK instrumental album／ROCK RECORDS CO.,LTD.﹙Performed by：Just Busy Music Studio﹚",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Instrumental Composer",
                "items": [
                  {
                    "text": "Tracy Yang／OR (Operating Room)《OR》／Feeling Good Music Co., Ltd﹙Performed by：Tracy Yang Jazz Orchestra﹚",
                    "winner": false
                  },
                  {
                    "text": "Tom Bourgeois／5 Flamingos《5 Flamingos》／ONYX Music Company﹙Performed by：Tom Bourgeois、Kuo Chun-Yu﹚",
                    "winner": false
                  },
                  {
                    "text": "Joyce Cheung／Étude No.1 in D - Carpark《The Études》／KKLIVE LIMITED﹙Performed by：Joyce Cheung、Dean Li、JAckiZ Tsang、Tsui Chin Hung、Sean Lai、Bernard Chan﹚",
                    "winner": false
                  },
                  {
                    "text": "WENG QU XIAN、Szx. 、HadiT、HAN SHU FAN／A Flying Kite《Eong》／PRO PROMOTING INTERNATIONAL CO LTD﹙Performed by：Eong、Szx.、HadiT﹚",
                    "winner": false
                  },
                  {
                    "text": "YuChia Wang、FlyingPP、Shan Lin／Triple Helix《How Many Hippos》／Counting Days Music﹙Performed by：How Many Hippos﹚",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "Technical - Individual Awards",
            "titles": [
              {
                "title": "Best Album Design",
                "items": [
                  {
                    "text": "Yueh Yueh Liu／People, Places, Things／Lyncean Development Co., Ltd.",
                    "winner": false
                  },
                  {
                    "text": "Yu Wei／Wang PiNk Ryu Freestyle／Sugarcane69",
                    "winner": false
                  },
                  {
                    "text": "FKWU、Hitsu、777much ／I See You／The Third Road Art LTD.",
                    "winner": false
                  },
                  {
                    "text": "Andrew Wong, Julie Yeh／Jug Band Millionaire／The Muddy Basin Ramblers",
                    "winner": false
                  },
                  {
                    "text": "Chanhee Hong、Na Kim／AAA／Sunset Music Productions Co., Ltd.",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "Technical - Record Label Awards",
            "titles": [
              {
                "title": "Best Vocal Album Recording",
                "items": [
                  {
                    "text": "My Nova／ Mr. Wing Creative CO., LTD. （Recording Engineers：Lin Shang-Po, Kao Chin-Lun, Ju Pin-Hao, Yi Lin Chen, Chou Han Tsay／Main Mixing Engineers：Yuchain Wang, Ziya Huang, ShenB, Howe／Main Mastering Post-Production：Alex Wharton ）",
                    "winner": false
                  },
                  {
                    "text": "Creeper／ HOW NICE ENTERTAINMENT CO ., LTD （Recording Engineers：Chou Han Tsay, dooodooo, J.J.Ciou, Zen Chien, Thomas Chuang／Main Mixing Engineers：Itun Chou／Main Mastering Post-Production：Itun Chou）新增項目",
                    "winner": false
                  },
                  {
                    "text": "South Expedition／ Floating Music （Recording Engineers：Jason Hsu, Zen Chien, Hardcore Chen, BonBon Chen, Chen Yi Lin, Chou Han Tsay, Pin-Hao Ju, Audry Garcia Dionsio, L8ching／Main Mixing Engineers：Jason Hsu,  Zen Chien, Hardcore Chen, Burgerlin, Ziya Huang／Main Mastering Post-Production：Alex Wharton）",
                    "winner": false
                  },
                  {
                    "text": "AAA／ Sunset Music Productions Co., Ltd. （Recording Engineers：SangHyun Cho, HyeSeok Oh, Yuchain Wang, YJ (Moollon), James Fouren／Main Mixing Engineers：Norman Nitzsche／Main Mastering Post-Production：Norman Nitzsche）",
                    "winner": true
                  },
                  {
                    "text": "Ordeal by Pearls／ POURQUOI PAS MUSIC LIMITED （Recording Engineers：Yi Lin Chen, Zen Chien, Yu Shih Cheng, Lin Shang-Po, Chou Han Tsay, Pin-Hao Ju, Agwen Yu／Main Mixing Engineers：Wayson Scream, Huang Shao Yong, Simon Li, Thomas Chuang, Ziya Huang, Cheng Chung Lin, Howe／Main Mastering Post-Production：Wayson Scream）",
                    "winner": false
                  },
                  {
                    "text": "VILLAIN／ Sony Music Entertainment Taiwan Ltd. （Recording Engineers：Chace, Alice／Main Mixing Engineers：Chace／Main Mastering Post-Production：Chace）",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Instrumental Album Recording",
                "items": [
                  {
                    "text": "OR／ Feeling Good Music Co., Ltd （Recording Engineers：Brian Montgomery／Main Mixing Engineers：Brian Montgomery／Main Mastering Post-Production：Mark Wilder）",
                    "winner": true
                  },
                  {
                    "text": "Aftertaste／ Debby Wang Music Studio （Recording Engineers：Chou Han Tsay／Main Mixing Engineers：Jay Cheng／Main Mastering Post-Production：Zino Mikorey）",
                    "winner": false
                  },
                  {
                    "text": "The Études／ KKLIVE LIMITED （Recording Engineers：Link Shan, Yu Shih Cheng, Chen Chia Ying／Main Mixing Engineers：Link Shan ／Main Mastering Post-Production：Jeff Lipton, Maria Rice, Costanza Tinti）",
                    "winner": false
                  },
                  {
                    "text": "7 Seven／ Sony Music Entertainment Taiwan Ltd. （Recording Engineers：You Li, Yu Han Zhang, Li Yang／Main Mixing Engineers：You Li／Main Mastering Post-Production：You Li）",
                    "winner": false
                  },
                  {
                    "text": "Ctrl+Z／ Sound of Tomorrow Ltd. （Recording Engineers：Chou Han Tsai／Main Mixing Engineers：Jay Cheng, Howe, Kevin Fu／Main Mastering Post-Production：Jeff Lipton）",
                    "winner": false
                  }
                ]
              },
              {
                "title": "Best Music Video",
                "items": [
                  {
                    "text": "Antenna《AAA》／Sunset Music Productions Co., Ltd.﹙Director：rafhoo﹚",
                    "winner": true
                  },
                  {
                    "text": "Young Man《AAA》／Sunset Music Productions Co., Ltd.﹙Director：Pennacky﹚",
                    "winner": false
                  },
                  {
                    "text": "Essential Blues《CHECK CHECK》／Night Only Ltd.﹙Director：Autotuna﹚",
                    "winner": false
                  },
                  {
                    "text": "Dab Hi《Dab Hi》／23 Co., Ltd.﹙Director：Teom Chen﹚",
                    "winner": false
                  },
                  {
                    "text": "Once a Dream《Disgusted Artist》／ROCK RECORDS CO.,LTD.﹙Director：Reago﹚",
                    "winner": false
                  },
                  {
                    "text": "Buzz《Buzz》／Sony Music Entertainment Taiwan Ltd.﹙Director：Isaac Ravishankara﹚",
                    "winner": false
                  }
                ]
              }
            ]
          },
          {
            "category": "Jury Award",
            "titles": [
              {
                "title": "Jury Award",
                "items": [
                  {
                    "text": "Khalil Fong The Dreamer Album",
                    "winner": true
                  }
                ]
              }
            ]
          },
          {
            "category": "Special Contribution Award",
            "titles": [
              {
                "title": "Special Contribution Award",
                "items": [
                  {
                    "text": "Xiao-Liang Weng",
                    "winner": true
                  },
                  {
                    "text": "Chao-Chun Ma",
                    "winner": true
                  }
                ]
              }
            ]
          }
        ]
      };
    }
    this.categoryTabs = this.AwardWinnersData.AwardWinners_Menu;
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    selectTab(categoryIndex) {
      this.selectedTab = categoryIndex;
      this.isGroupOpen = this.categoryTabs[categoryIndex].titles.map(() => false);
    },
    toggleGroup(titleIndex) {
      this.$set(this.isGroupOpen, titleIndex, !this.isGroupOpen[titleIndex]);
    },
  },
};
</script>